import styled from 'styled-components';

import ImageBannerSquare1 from '../../assets/banner-image-square-1.jpg';
import ImageBannerSquare2 from '../../assets/banner-image-square-2.jpg';
import ImageBannerSquare3 from '../../assets/banner-image-square-3.jpg';
import ImageBannerSquare4 from '../../assets/banner-image-square-4.jpg';
import ImageBannerSquare5 from '../../assets/banner-image-square-5.jpg';

export const LandingContainer = styled.div`

    #banner {
        position: relative;
        display: flex;
        align-items: center;

        min-height: 90rem;
        height: 80vh;
        
        .content {
            position: relative;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            .text {
                width: 53rem;

                h1 {
                    font-size: 5.5rem;
                    line-height: 140%;

                    span {
                        background: linear-gradient(90deg, var(--nooio-gradient), var(--color-primary));
                        background-size: 300%;
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;

                        animation: text-bg 10s linear infinite;

                        @keyframes text-bg {
                            0%{
                                background-position: 0%;
                            }

                            50% {
                                background-position: 100%;
                            }

                            100% {
                                background-position: 150%;
                            }
                        }
                    }
                }

                p {
                    font-size: 1.8rem;
                    font-weight: 600;
                    line-height: 150%;

                    margin: 2rem 0 5rem;
                }

                .buttons {
                    display: flex;

                    .button {
                        height: 4.5rem;
                        padding: 0 4rem;

                        --color-primary: #000;
                        
                        & + .button {
                            margin-left: 2rem;
                        }
                    }
                }
            }

            .asset {
                position: relative;
                
                width: 45rem;
                height: 40rem;

                // border: 1px solid #000;

                .square {
                    position: absolute;
                    bottom: 0;

                    width: 17rem;
                    height: 17rem;
                    border-radius: 1rem;

                    overflow: hidden;

                    &.first {
                        top: 1rem;
                        bottom: none;
                        right: none;
                        left: 4rem;

                        background: url(${ImageBannerSquare1}) no-repeat 50% 0/130%;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-primary);
                            opacity: .5;
                        }
                    }

                    &.second {
                        top: -2rem;
                        bottom: none;
                        right: -3rem;
                        left: none;

                        background: url(${ImageBannerSquare4}) no-repeat 120% 54%/108%;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-secondary);
                            opacity: .5;
                        }
                    }

                    &.third {
                        top: none;
                        bottom: 1rem;
                        right: 3rem;
                        left: none;
                        
                        background: url(${ImageBannerSquare2}) no-repeat 18% 62%/230%;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-tertiary);
                            opacity: .5;
                        }
                    }

                    &.fourth {
                        top: none;
                        bottom: 12rem;
                        right: 12rem;
                        left: none;

                        background: url(${ImageBannerSquare3}) no-repeat 1% 53%/127%;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-quaternary);
                            opacity: .5;
                        }
                    }

                    &.fifth {
                        top: none;
                        bottom: -2rem;
                        right: none;
                        left: 2rem;

                        background: url(${ImageBannerSquare5}) no-repeat 2% 47%/133%;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-quinary);
                            opacity: .5;
                        }
                    }
                }
            }
        }

        .scroll-indicator {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, -50%);

            .mouse {
                position: relative;

                width: 3rem;
                height: 5rem;

                border-radius: 2rem;
                border: 1px solid #000;

                .scroll {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);

                    width: .5rem;
                    height: .5rem;
                    margin: 1rem 0;

                    background: rgba(0, 0, 0, .7);
                    border-radius: 50%;

                    animation: scrollIndicatorAnimation 2s ease-in-out infinite;
                }

                @keyframes scrollIndicatorAnimation {
                    0% {
                        transform: translateX(-50%) translateY(0);
                        opacity: .8;
                    }

                    80% {
                        transform: translateX(-50%) translateY(calc(5rem - 2rem - .5rem));
                        opacity: 1;
                    }

                    100% {
                        transform: translateX(-50%) translateY(calc(5rem - 2rem - .5rem));
                        opacity: 0;
                    }
                }
            }
        }
    }

    #how-it-works {
        position: relative;
        // min-height: 80rem;
        
        padding: 7rem 0 10rem;
        
        overflow: hidden;

        .shadow {
            background: linear-gradient(135deg, var(--nooio-gradient), transparent, transparent, transparent, transparent);
            opacity: 0;
            // filter: blur(100px);
        }

        .lines-square {
            position: absolute;
            top: 0;
            left: -10rem;

            width: 50%;
            transform: rotate(-45deg);

            .line {
                height: 5rem;
                width: 100%;

                background: red;

                + .line {
                    margin-top: 5rem;
                }
            }
        }

        .content {
            position: relative;
            overflow: visible;

            .heading {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;

                h1 {
                    font-size: 3.5rem;
                    line-height: 125%;
                }
            }

            .grid-steps {
                display: flex;
                justify-content: space-between;

                margin: 10rem 0;

                .steps {
                    position: relative;
        
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 0 5rem;
                    grid-template-areas:
                        "one two"
                        "three three"
                    ;
        
                    width: 55rem;
        
                    .step {
                        width: 100%;
        
                        // border: 1px solid #ddd;
        
                        h1 {
                            font-size: 8rem;
        
                            background: #000;
                            background-clip: text;
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }
        
                        h2 {
                            font-size: 1.8rem;
                            margin: 0 0 2rem;
                        }
        
                        p {
                            font-size: 1.4rem;
                            font-weight: 600;
                            line-height: 150%;
                        }
        
                        &:nth-child(1) {
                            grid-area: one;
        
                            h1 {
                                background-image: linear-gradient(135deg, var(--color-primary), var(--color-secondary), var(--color-secondary));
                            }
                        }
        
                        &:nth-child(2) {
                            grid-area: two;
        
                            h1 {
                                background-image: linear-gradient(135deg, var(--color-tertiary), var(--color-quaternary), var(--color-quaternary));
                            }
                        }
        
                        &:nth-child(3) {
                            grid-area: three;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
        
                            padding-right: 10%;
        
                            h1 {
                                font-size: 12rem;
                                line-height: 12rem;
                                margin-right: 3rem;
        
                                background-image: linear-gradient(135deg, var(--color-quaternary), var(--color-quinary), var(--color-quinary), var(--color-quinary));
                            }
        
                            h2 {
                                font-size: 2rem;
                                margin: 0 0 1.5rem;
                            }
        
                            p {
                                font-size: 1.6rem;
                            }
        
                        }
                    }
        
                    .arrows {
        
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
        
                        display: grid;
                        grid-template-columns: 5rem 5rem;
                        place-items: center;
                        place-content: center;
                        // gap: calc(30rem + ((100% - (30rem * 3)) / 2) / 2 );
        
                        width: 100%;
        
                        pointer-events: none;
                        display: none;
        
                        .arrow {
                            display: flex;
                            align-items: center;
                            justify-content: center;
        
                            width: 5rem;
                            height: 5rem;
        
                            // border: 1px solid #ddd;
        
                            i {
                                font-size: 1.4rem;
                                animation: arrow-animation 2s linear infinite;
        
                                color: #000;
        
                                &:nth-child(2) {
                                    animation-delay: .2s;
                                }
        
                                &:nth-child(3) {
                                    animation-delay: .4s;
                                }
                            }
        
                            &:last-child {
                                i {
                                    animation-delay: .6s;
        
                                    &:nth-child(2) {
                                        animation-delay: .8s;
                                    }
            
                                    &:nth-child(3) {
                                        animation-delay: 1s;
                                    }
                                }
                            }
                        }
        
                        @keyframes arrow-animation {
                            0%, 100% {
                                opacity: 1;
                            }
        
                            50% {
                                opacity: 0;
                            }
                        }
                    }
                }

                .assets {
                    position: relative;
                    width: 50rem;
                    height: 50rem;
                    // background: red;

                    .squares {
                        position: absolute;
                        top: 50%;
                        right: 0;

                        width: 100%;
                        height: 100%;

                        transform: translate(50%, -50%) rotate(-45deg);

                        .square {
                            position: absolute;
                            width: 100%;
                            height: 100%;

                            background: #f0f;
                            border-radius: 3rem;
                            opacity: .8;

                            &:nth-child(1) {
                                transform: rotate(calc(0 * 7deg));
                                background: var(--color-primary);
                                z-index: 10;
                            }
                            &:nth-child(2) {
                                transform: rotate(calc(1 * 7deg));
                                background: var(--color-secondary);
                                z-index: 8;
                            }
                            &:nth-child(3) {
                                transform: rotate(calc(2 * 7deg));
                                background: var(--color-tertiary);
                                z-index: 6;
                            }
                            &:nth-child(4) {
                                transform: rotate(calc(3 * 7deg));
                                background: var(--color-quaternary);
                                z-index: 4;
                            }
                            &:nth-child(5) {
                                transform: rotate(calc(4 * 7deg));
                                background: var(--color-quinary);
                                z-index: 2;
                            }
                        }

                    }

                    iframe {
                        position: absolute;
                        top: 50%;
                        right: -3rem;
                        transform: translateY(-50%);

                        width: 53rem;
                        width: 100%;
                        height: 30.5rem;

                        border-radius: 2rem;
                    }
                }
            }

            button {
                margin: 0 auto;

                height: 4.7rem;
                padding: 0 4rem;
            }
        }
    }

    #about {
        .content {
            padding: 7rem 0 10rem;

            .heading {
                text-align: center;
                margin-bottom: 7rem;

                h1 {
                    font-size: 3.5rem;
                    line-height: 125%;
                }
            }

            .flex-about {
                display: flex;
                align-items: center;

                + .flex-about {
                    margin-top: 15rem;
                }

                &.flex-reverse {
                    flex-direction: row-reverse;

                    .image {
                        margin-left: 0;
                        margin-right: 10rem;
                    }
                }

                .text {
                    position: relative;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    min-height: 30rem;

                    h2 {
                        font-size: 2.7rem;
                        font-family: 'Open Sans', sans-serif;
                        margin-bottom: 1.5rem;
                    }

                    p {
                        font-size: 1.7rem;
                        line-height: 150%;
                    }

                    img {
                        position: absolute;
                        bottom: 0;
                        right: 0;

                        transform: translate(40%, 80%) rotate(15deg);

                        width: 20rem;

                        pointer-events: none;
                        user-select: none;
                    }
                }
                
                .image {
                    width: 50rem;
                    height: 30rem;
                    margin-left: 10rem;

                    box-shadow: 1rem 1rem 5rem rgba(0, 0, 0, .2);
                    border-radius: 1rem;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
    }

    #faq {
        .content {
            display: flex;
            flex-direction: row-reverse;
            align-items: flex-start;
            justify-content: space-between;

            padding: 15rem 0;

            .asset {
                width: 45rem;
                height: 45rem;

                img {
                    width: 100%;
                    height: 100%;

                    object-fit: contain;
                }
            }

            .faq-container {
                flex: 1;

                // margin-left: 15rem;
                margin-right: 15rem;

                .heading {
                    width: 100%;
                    text-align: left;
        
                    h1 {
                        font-size: 3.5rem;
                    }
        
                    p {
                        font-size: 1.6rem;
                        margin-top: .5rem;
                    }
                }

                .faq-items {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 1rem;
                    
                    margin-top: 5rem;

                    .faq-item {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;

                        width: 100%;
                        max-height: 5.5rem;

                        background: transparent;
                        border-radius: 1rem;

                        overflow: hidden;
                        cursor: pointer;
                        transition: .3s;

                        &::before {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            // opacity: .5;
                            background: #000;
                        }

                        &:nth-child(1)::before {
                            background-image: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
                        }
                        &:nth-child(2)::before {
                            background-image: linear-gradient(135deg, var(--color-secondary), var(--color-tertiary));
                        }
                        &:nth-child(3)::before {
                            background-image: linear-gradient(135deg, var(--color-tertiary), var(--color-quaternary));
                        }
                        &:nth-child(4)::before {
                            background-image: linear-gradient(135deg, var(--color-quaternary), var(--color-quinary));
                        }
                        &:nth-child(5)::before {
                            background-image: linear-gradient(135deg, var(--color-quinary), var(--color-primary));
                        }
                        &:nth-child(6)::before {
                            background-image: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
                        }

                        .question {
                            position: absolute;
                            top: 0;
                            left: 0;

                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            z-index: 3;
                            flex: 1;

                            width: 100%;
                            height: 5.5rem;
                            padding: 0 3rem;

                            pointer-events: none;

                            span {
                                font-size: 1.6rem;
                                font-weight: bold;
                                background: #000;
                                background-clip: text;
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                            }

                            i {
                                font-size: 1.4rem;
                                color: #000;
                                transition: .3s;
                            }
                        }

                        .answer {
                            width: 100%;
                            min-height: 20rem;
                            margin-top: 5.5rem;

                            background: #ddd;
                        }

                        &.active {
                            max-height: 30rem;

                            .question {
                                i {
                                    transform: rotate(180deg);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    #testimonials {
        background: #f1f1f1;

        .content {
            padding: 7rem 0;

            .heading {
                text-align: center;
                
                h1 {
                    font-size: 3rem;
                }
            }

            .swiper-container {
                width: 100%;
                height: 100%;
                margin: auto;
                margin-top: 7rem;
                padding-bottom: 5rem;

                .swiper-wrapper {
                    width: 100%;

                    .swiper-slide {
                        position: relative;
                        width: 100%;
                        min-height: 20rem;

                        padding: 4rem;

                        background: #fff;
                        border-radius: .5rem;

                        user-select: none;

                        &::before {
                            position: absolute;
                            content: '';
                            bottom: 0;
                            left: 0;

                            width: 100%;
                            height: 2px;
                            background: linear-gradient(90deg, var(--nooio-gradient));
                        }

                        img.aspas {
                            position: absolute;
                            top: 4rem;
                            right: 4rem;

                            width: 7rem;
                            
                            opacity: .18;
                        }

                        .people {
                            display: flex;
                            align-items: center;

                            img {
                                width: 6em;
                                height: 6em;
                                margin-right: 1.5rem;
                                object-fit: cover;

                                border-radius: 50%;
                            }

                            .info {
                                display: flex;
                                flex-direction: column;

                                strong {
                                    font-size: 1.6rem;
                                }

                                span {
                                    font-size: 1.2rem;
                                    font-weight: 300;
                                    margin-top: .1rem;
                                }
                            }
                        }

                        .what-said {
                            margin-top: 3rem;

                            p {
                                font-size: 1.5rem;
                                line-height: 160%;

                            }
                        }
                    }
                }
            }
        }
    }

    #lasted-posts {
        .content {
            position: relative;
        
            padding: 7rem 0;

            .blur {
                position: absolute;
                top: 5rem;
                left: 0;
                transform: translateX(-50%);

                display: none;
        
                width: 50rem;
                height: 50rem;
                
                background: radial-gradient(rgba(236, 103, 37, 1), rgba(236, 103, 37, 0.663), transparent);
                opacity: 1;
                border-radius: 50%;
            }

            .squares {
                position: absolute;
                top: 2rem;
                left: 0;
                transform: translateX(-80%);

                display: grid;
                grid-template-columns: repeat(2, 5rem);
                gap: 2rem;
                place-items: center;
                place-content: center;

                opacity: .5;
                
                // width: 45rem;
                // height: 40rem;

                &:nth-child(2) {
                    top: unset;
                    bottom: -5rem;
                    left: unset;
                    right: 0;
                    transform: translateX(100%);
                }

                .square {
                    position: relative;

                    width: 5rem;
                    height: 5rem;
                    border-radius: 1rem;

                    overflow: hidden;

                    &.first {
                        // top: 0rem;
                        // left: 0rem;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-primary);
                            opacity: 1;
                        }
                    }

                    &.second {
                        // top: -0rem;
                        // right: -0rem;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-secondary);
                            opacity: 1;
                        }
                    }

                    &.third {
                        // bottom: 0rem;
                        // right: 0rem;
                    
                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-tertiary);
                            opacity: 1;
                        }
                    }

                    &.fourth {
                        // bottom: 10rem;
                        // right: 10rem;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-quaternary);
                            opacity: 1;
                        }
                    }

                    &.fifth {
                        // bottom: -0rem;
                        // left: 0rem;

                        &::after {
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;

                            width: 100%;
                            height: 100%;

                            background: var(--color-quinary);
                            opacity: 1;
                        }
                    }
                }
            }

            .heading {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;

                h1 {
                    font-size: 3.5rem;
                    line-height: 140%;
                }
            }

            .wrapper {
                position: relative;
            }

            .posts {
                position: relative;
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 4rem;

                width: 100%;
                margin: 7rem 0;
                

                .post {
                    width: 100%;
                    // min-height: 40rem;

                    border-radius: .7rem;
                    border: 1px solid rgba(0, 0, 0, .1);
                    box-shadow: .5rem .5rem 2rem rgba(0, 0, 0, .1);
                    background: #fff;

                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 15rem;
                        object-fit: cover;
                    }

                    .text {
                        position: relative;
                        display: flex;
                        flex-direction: column;

                        padding: 3rem 2rem 5rem;

                        a {
                            position: absolute;
                            top: 0;
                            right: 2rem;
                            transform: translateY(-50%);
                            
                            display: flex;
                            align-items: center;

                            height: 4rem;
                            padding: 0 2rem;
                            
                            border-radius: 5rem;
                            background: linear-gradient(150deg, var(--color-primary), var(--color-tertiary));
                            background: linear-gradient(150deg, var(--color-quaternary), var(--color-quinary));

                            opacity: 0;

                            span, i {
                                font-size: 1.4rem;
                                font-weight: 600;
                                color: #fff;
                            }
                            span {
                                margin-right: 1rem;
                            }
                        }

                        span {
                            font-size: 1.3rem;
                            font-weight: 300;
                            color: rgba(0, 0, 0, .6);
                        }

                        strong {
                            font-size: 1.6rem;
                            margin: .5rem 0 1rem;
                        }

                        p {
                            font-size: 1.4rem;
                            line-height: 140%;
                        }
                    }

                    &:hover .text a {
                        opacity: 1;
                        transition: .3s;
                    }
                }
            }
        }
    }

    #newsletter {
        .content {
            .newsletter {
                position: relative;
                transform: translateY(50%);
                z-index: 10;

                display: flex;
                align-items: center;
                justify-content: space-between;

                height: 20rem;
                width: 80%;
                margin: 0 auto;
                padding: 4rem;

                // background: linear-gradient(45deg, var(--color-quaternary), var(--color-quinary));
                background: #fff;
                border: 1px solid rgba(0, 0, 0, .1);
                border-radius: 1rem;
                box-shadow: 0 0 100px rgba(0, 0, 0, .15);

                > div {
                    h2 {
                        font-size: 2rem;
                        font-weight: lighter;
                    }

                    h1 {
                        font-size: 2.5rem;
                        // margin-top: .5rem;
                    }
                }

                form {
                    display: flex;

                    height: 5rem;

                    .input {
                        position: relative;

                        width: 25rem;
                        height: 5rem;

                        background: #ddd;
                        border: 1px solid #ddd;
                        border-radius: .5rem;

                        overflow: hidden;

                        input {
                            width: 100%;
                            height: 5rem;
                            padding: 0 2.5rem;

                            font-size: 1.4rem;
                            font-weight: bold;
                            
                            border-radius: .5rem;
                            background: transparent;
                            color: #000;

                            &::placeholder {
                                font-weight: 400;
                            }
                        }
                    }

                    .button {
                        height: 5rem;
                        margin-left: 1.5rem;
                        padding: 0 2.3em;

                        border-radius: .5rem;
                    }
                }
            }
        }
    }

    @media (max-width: 540px) {

        #banner {
            height: auto;
            min-height: 90vh;

            padding: 27.77778vw 0 18vw;

            .content {
                flex-direction: column-reverse;
                align-items: center;
                justify-content: center;

                .text {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    
                    width: 100%;

                    h1 {
                        font-size: 8.33333vw;
                    }

                    p {
                        font-size: 3.33333vw;
                        width: 92%;
                        margin: 3.33333vw auto 8.33333vw;
                    }
                }

                .asset {
                    width: 72.22222vw;
                    height: 63.88889vw;

                    margin: 18.05556vw 0 13.88889vw;

                    .square {
                        width: 28.33333vw;
                        height: 28.33333vw;
                        border-radius: 1.66667vw;

                        &.first {
                            top: 0;
                            left: 3.33333vw;
                        }

                        &.second {
                            top: -3.33333vw;
                            bottom: none;
                            right: -5.00000vw;
                        }

                        &.third {
                            top: none;
                            bottom: 1.66667vw;
                            right: 5.00000vw;
                        }

                        &.fourth {
                            top: none;
                            bottom: 20.00000vw;
                            right: 20.00000vw;
                        }

                        &.fifth {
                            left: 0;
                        }
                    }
                }
            }

            .scroll-indicator {
                display: none;
            }
        }

        #how-it-works {
            padding: 11.66667vw 0 16.66667vw;

            .content {
                .heading {
                    h1 {
                        font-size: 7.77778vw;
                    }
                }

                .grid-steps {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    margin: 16.66667vw 0;

                    .steps {    
                        grid-template-columns: 1fr;
                        grid-template-areas: 
                            "one"
                            "two"
                            "three"
                        ;
                        gap: 9vw;
                        
                        width: 100%;

                        margin-bottom: 18vw;

                        .step, .step:nth-child(3) {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            text-align: left;

                            width: 80%;
                            margin: 0 auto;


                            h1 {
                                font-size: 18vw;
                                margin-right: 5.00000vw;
                            }

                            h2 {
                                font-size: 3.7vw;
                                margin: 0 0 1.5vw;
                            }
        
                            p {
                                font-size: 2.8vw;
                            }

                            &:nth-child(3) {
                                padding-right: 0;
                            }
                        }
                    }

                    .assets {
                        width: 100%;

                        .squares {
                            left: 50%;
                            right: unset;
                            transform: translate(-50%, -50%);

                            width: 75%;
                            height: 75%;
                        }

                        iframe {
                            right: unset;
                            left: 50%;
                            transform: translate(-50%, -50%);

                            width: 61.66667vw;
                            height: 43.5vw;
                        }
                    }
                }
            }
        }

        #about {
            .content {
                .heading {
                    margin-bottom: 19.44444vw;

                    h1 {
                        font-size: 7.77778vw;

                        br {
                            display: none;
                        }
                    }
                }

                .flex-about, .flex-about.flex-reverse {
                    flex-direction: column-reverse;
                    
                    + .flex-about {
                        margin-top: 13.88889vw;
                    }

                    .text {    
                        justify-content: unset;
                        text-align: center; 

                        min-height: unset;

                        h2 {
                            font-size: 5.00000vw;
                            margin-bottom: 1.5rem;
                        }
        
                        p {
                            font-size: 3.33333vw;
                        }
        
                        img {
                            display: none;
                        }
                    }

                    .image {
                        width: 71.66667vw;
                        height: 46.66667vw;
                        
                        margin: 0 0 8.33333vw;
                    }
                }
            }
        }

        #testimonials {
            .content {
                padding: 19.44444vw 0;

                .heading {
                    h1 {
                        font-size: 7.77778vw;
                    }
                }

                .swiper-container {
                    margin-top: 13.88889vw;
                    padding-bottom: 13.88889vw;

                    .swiper-wrapper {
                        .swiper-slide {

                            .people {
                                img {
                                    width: 11.11111vw;
                                    height: 11.11111vw;
                                    margin-right: 3.88889vw;
                                }
        
                                .info {
                                    strong {
                                        font-size: 3.33333vw;
                                    }
        
                                    span {
                                        font-size: 2.50000vw;
                                        margin-top: 0.19444vw;
                                    }
                                }
                            }

                            .what-said {
                                p {
                                    font-size: 2.77778vw;
                                }
                            }
                        }
                    }
                }
            }
        }

        #faq {
            .content {
                padding: 11.66667vw 0;

                .asset {
                    display: none;
                }

                .faq-container {
                    margin-right: 0;

                    .heading {
                        width: 80%;
                        text-align: center;
                        margin: 0 auto;
            
                        h1 {
                            font-size: 7.77778vw;
                        }
            
                        p {
                            font-size: 3.33333vw;
                            margin-top: 1.38889vw;
                        }
                    }

                    .faq-items {
                        margin-top: 10.27778vw;
                        gap: 1.38889vw;

                        .faq-item {
                            max-height: 11.11111vw;

                            .question {
                                height: 11.11111vw;

                                span {
                                    flex: 1;
                                    font-size: 3.33333vw;
                                    margin-right: 3rem;
                                }
                            }
                        }
                    }
                }
            }
        }

        #lasted-posts {
            .content {
                padding: 15vw 0;

                .squares {
                    grid-template-columns: repeat(2, 5.55556vw);
                    gap: 2.77778vw;

                    &, &:nth-child(2) {
                        top: 50%;
                        bottom: unset;
                        transform: translate(0, -50%);
                    }

                    & {
                        transform: translate(0, -50%) translateY(-200%);

                        &:nth-child(2) {
                            transform: translate(0, -50%) translateY(312%);
                        }
                    }
                    

                    .square {
                        width: 5.55556vw;
                        height: 5.55556vw;
                    }
                }

                .heading {
                    position: relative;
                    z-index: 10;

                    h1 {
                        font-size: 7.77778vw;
                        line-height: 125%;

                        br {
                            display: none;
                        }
                    }
                }

                .posts {
                    grid-template-columns: repeat(4, 55.55556vw);
                    overflow-x: scroll;
                    scroll-snap-type: x mandatory;
                    
                    &::-webkit-scrollbar {
                        display: none;
                    }

                    .post {
                        scroll-snap-align: center;

                        img {
                            height: 33.33333vw;
                        }

                        .text {
                            padding: 5.00000vw 4.16667vw 8.33333vw;

                            a {
                                height: 8.33333vw;
                                padding: 0 4.72222vw;

                                span, i {
                                    font-size: 2.77778vw;
                                }
                            }

                            span {
                                font-size: 2.50000vw;
                            }

                            strong {
                                font-size: 3.61111vw;
                            }

                            p {
                                font-size: 2.91667vw;
                            }
                        }
                    }
                }
            }
        }

        #newsletter {
            .content {
                .newsletter {
                    flex-direction: column;
                    justify-content: unset;
                    text-align: center;

                    height: auto;
                    width: 100%;

                    > div {
                        margin-bottom: 6.94444vw;
                    }

                    form {
                        .input {
                            input {
                                position: absolute;
                                top: 0;
                                left: 0;

                                width: 100%;
                                height: 100%;

                                font-size: 2.50000vw;
                            }
                        }

                        .button {
                            font-size: 2.77778vw;
                        }
                    }
                }
            }
        }
    }
`;
